import ProgressBarComponent from './ProgressBarComponent';

export default ProgressBarComponent;
